import React from 'react'
import useNavigationAnalytics from '../analytics/hooks/useNavigationAnalytics'

const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	useNavigationAnalytics()
	return <>{children}</>
}

export default AnalyticsWrapper
